import { closeFunctionverificationCode } from '@/client/app/apis/closeFunctionverificationCode'
import { useSetState } from 'ahooks'
import { Button, Form, Input, Modal, Space, message } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useRef, useState } from 'react'
import { ISkuTypeEnums } from '../interface'

let timer: any = null
interface IClosedConfirmProps {
	visible: boolean
	managerName: string
	aid: string
	cid: string
	typeEnums: ISkuTypeEnums
	onCancel: () => void
	submitFunc: (params?: { verificationCode: string }) => Promise<any>
}
const ClosedConfirm: React.FC<IClosedConfirmProps> = (props) => {
	const endDate = dayjs().format('YYYY-MM-DD')
	const [state, setState] = useSetState<{
		disabled: boolean
		countdown: number
	}>({
		disabled: false,
		countdown: 0,
	})
	const [form] = Form.useForm()
	useEffect(() => {
		if (!props.visible) {
			form.resetFields()
			clearInterval(timer)
			setState({ disabled: false, countdown: 0 })
		}
	}, [props.visible])
	const countdownRef = useRef(state.countdown)
	const startCountdown = () => {
		const duration = 59
		setState({ countdown: duration, disabled: true })
		countdownRef.current = duration
		timer = setInterval(() => {
			countdownRef.current = countdownRef.current - 1
			if (countdownRef.current > 0) {
				setState({ countdown: countdownRef.current })
			} else {
				clearInterval(timer)
				setState({ disabled: false })
			}
		}, 1000)
	}
	const sendCode = () => {
		closeFunctionverificationCode({
			aid: props.aid,
			cid: props.cid,
			typeEnums: props.typeEnums,
		}).then(() => {
			message.success('验证码发送成功，请注意查收')
			startCountdown()
		})
	}
	const submit = () => {
		form.validateFields().then((values) => {
			const { code } = values
			props.submitFunc({ verificationCode: code }).then(() => {
				props.onCancel()
			})
		})
	}
	return (
		<Modal
			width={600}
			title="关闭功能校验"
			cancelText="取消"
			okText="确认关闭功能"
			destroyOnClose={true}
			open={props.visible}
			onOk={submit}
			onCancel={() => {
				props.onCancel()
			}}
		>
			<Space direction="vertical">
				<div>输入验证码后关停功能（点击发送将通过POPO及邮件发送给跟进人）</div>
				<div>跟进人：{props.managerName}</div>
				<div>本次验证码有效期截至 {endDate} 23:59:59</div>
				<Space align="start">
					<Form form={form}>
						<Form.Item
							name="code"
							rules={[
								{ required: true, message: '请输入验证码' },
								{ pattern: /^\d{6}$/, message: '验证码格式错误' },
							]}
						>
							<Input placeholder="请输入6位验证码" maxLength={6} />
						</Form.Item>
					</Form>
					<Button type="primary" disabled={state.disabled} onClick={sendCode}>
						发送给销售{state.disabled && `(${state.countdown})`}
					</Button>
				</Space>
			</Space>
		</Modal>
	)
}
export default ClosedConfirm
const useClosedConfirm = () => {
	type IShowProps = Omit<IClosedConfirmProps, 'visible'>
	const [visible, setVisible] = useState(false)
	const [data, setData] = useState<IShowProps>()
	return {
		showClosedConfirm: (data: Omit<IShowProps, 'managerName' | 'onCancel'> & { managerName?: string }) => {
			if (data.managerName) {
				setVisible(true)
				setData(data as IShowProps)
			} else {
				data.submitFunc()
			}
		},
		ClosedConfirmContext: data && <ClosedConfirm {...data} visible={visible} onCancel={() => setVisible(false)} />,
	}
}
export { useClosedConfirm }
